import React from 'react';
import * as PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ButtonContainer, Button } from 'components/button/index';

export const UploadFormControls = ({ onCancel, isPublishDisabled = false }) => {
  const { t } = useTranslation();
  return (
    <div className="upload-form-controls">
      <div className="upload-form-controls__note">* {t('mandatory_fields')}</div>
      <ButtonContainer>
        <Button onClick={onCancel} secondary={true} id="cancel-upload">
          {t('cancel')}
        </Button>
        <Button type="submit" disabled={isPublishDisabled}>
          {t('publish')}
        </Button>
      </ButtonContainer>
    </div>
  );
};

UploadFormControls.propTypes = {
  onCancel: PropTypes.func.isRequired,
  isPublishDisabled: PropTypes.bool,
};
